import { render, staticRenderFns } from "./DeviceWorkOrderRecord.vue?vue&type=template&id=2dfe734c&scoped=true"
import script from "./DeviceWorkOrderRecord.vue?vue&type=script&lang=js"
export * from "./DeviceWorkOrderRecord.vue?vue&type=script&lang=js"
import style0 from "./DeviceWorkOrderRecord.vue?vue&type=style&index=0&id=2dfe734c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe734c",
  null
  
)

export default component.exports